var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33366 0.833008C5.58476 0.833008 4.16699 2.25077 4.16699 3.99967C4.16699 5.74858 5.58476 7.16634 7.33366 7.16634C9.08256 7.16634 10.5003 5.74858 10.5003 3.99967C10.5003 2.25077 9.08256 0.833008 7.33366 0.833008ZM5.16699 3.99967C5.16699 2.80306 6.13704 1.83301 7.33366 1.83301C8.53028 1.83301 9.50033 2.80306 9.50033 3.99967C9.50033 5.19629 8.53028 6.16634 7.33366 6.16634C6.13704 6.16634 5.16699 5.19629 5.16699 3.99967Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33366 8.16634C3.58476 8.16634 2.16699 9.58411 2.16699 11.333C2.16699 13.0819 3.58476 14.4997 5.33366 14.4997H9.33366C9.6098 14.4997 9.83366 14.2758 9.83366 13.9997C9.83366 13.7235 9.6098 13.4997 9.33366 13.4997H5.33366C4.13704 13.4997 3.16699 12.5296 3.16699 11.333C3.16699 10.1364 4.13704 9.16634 5.33366 9.16634H9.33366C9.6098 9.16634 9.83366 8.94248 9.83366 8.66634C9.83366 8.3902 9.6098 8.16634 9.33366 8.16634H5.33366Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 9.33301C12.5003 9.05687 12.2765 8.83301 12.0003 8.83301C11.7242 8.83301 11.5003 9.05687 11.5003 9.33301V10.833H10.0003C9.72418 10.833 9.50033 11.0569 9.50033 11.333C9.50033 11.6091 9.72418 11.833 10.0003 11.833H11.5003V13.333C11.5003 13.6091 11.7242 13.833 12.0003 13.833C12.2765 13.833 12.5003 13.6091 12.5003 13.333V11.833H14.0003C14.2765 11.833 14.5003 11.6091 14.5003 11.333C14.5003 11.0569 14.2765 10.833 14.0003 10.833H12.5003V9.33301Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFriend);
export default __webpack_public_path__ + "static/media/AddFriend.ff4e1c38834b9eb238e683ed8069a1cd.svg";
export { ForwardRef as ReactComponent };